import InputConfirmation from './InputConfirmation';

export default InputConfirmation;
